import React from "react";
import * as oidcApi from "./oidcApi";
import { generateStateAndNonce } from "./actions/login";
import {Loader} from "./Components/Utils/Loader";
import { useSelector, useDispatch } from "react-redux";

const LoginPage = () => {
  const token = useSelector((state) => state.tokenReducer);
  const dispatch = useDispatch();
  const { state, nonce } = token;

  if (state === null || nonce === null) {
    dispatch(generateStateAndNonce());
  } else {
    oidcApi.beginAuth({ state, nonce });
  }

  return <Loader />;
};

export default LoginPage;
